// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"795706117eb07b9882d5","245":"3243ad776dd8557c7ff9","452":"53c4e4a30b349e7b5222","453":"947eeeda2fefe373c15c","522":"54149d3ffb91634e36f6"}[chunkId] + ".js";
};